<template>
    <div>
        
        <DoctorMap />
    </div>
</template>

<script setup>

const {searchQuery, searchResults, getSearchResults, listFocusIndex} = useSearch()
const route = useRoute()
onMounted( () => {
    
    if (searchResults.value?.length == 0)
    {
        console.debug("Search Results is empty")
        if (route.query.search)
        {
            getSearchResults(route.query.search)
        }
        else {
            getSearchResults("内科")
        }
        
    }
    else {
        console.debug("Search Results ok")
    }
    
    
    // getSearchResults("")

})

useSeoMeta({
    title: `搜索纽约医生 | 北美好医生`,
    ogTitle: `搜索纽约医生 | 北美好医生`,
    description: `纽约医生 | 北美好医生`,

})

useServerSeoMeta({
    title: `搜索纽约医生 | 北美好医生`,
    ogTitle: `搜索纽约医生 | 北美好医生`,
    description: `纽约医生 | 北美好医生`,
    ogDescription: `纽约医生 | 北美好医生`,
    ogImage: '~assets/img/HYS-logo-icon-06.png',
    robots: "index, follow"
})

</script>